module.exports = __webpack_public_path__ + "static/media/ico-showhide.cd30cefb.svg";